import { BrazeInboxMessageCardDto } from '@marketplace-web/braze/braze-data'
import { ConversationListItemType } from '@marketplace-web/messaging/conversation-providers-feature'

export const isBrazeConversation = (
  conversation: ConversationListItemType,
): conversation is BrazeInboxMessageCardDto => 'extras' in conversation
